export default "__VITE_ASSET__SsDB0Kjo__"